import axios from "axios";
import LanguageInterceptor from "./interceptor/LanguageInterceptor";

var instance =  axios.create();

instance.interceptors.request.use(LanguageInterceptor);

export default instance;